import store from '..';
import { Printer } from '../../models';
import { Printers, SioBridge } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState,
    getReducer, listReducer, updateReducer,
    getAction, listAction, updateAction
} = createRestSlices(Printers);

initialState.isForgetting = false;
initialState.successfullyForgot = false;
initialState.failedToForget = false;

const RESET = 'kronos/printers/RESET';
const LOADING_PRINTERS_SUCCESS = 'kronos/printers/LOADING_ITEMS_SUCCESS';
const FORGET = 'kronos/printers/FORGET';
const FORGET_SUCCEEDED = 'kronos/printers/FORGET_SUCCEEDED';
const FORGET_FAILED = 'kronos/printers/FORGET_FAILED';
const forgetReducer = (state = initialState, action) => {
    switch(action.type) {
        case RESET:
            return {
                ...state,
                printers: [],
                printer: null,
                isForgetting: false,
                successfullyForgot: false,
                failedToForget: false,
            };
        case LOADING_PRINTERS_SUCCESS:
            return {
                ...state,
                isForgetting: false,
                successfullyForgot: false,
                failedToForget: false,
            };
        case FORGET:
            return {
                ...state,
                isForgetting: true,
                successfullyForgot: false,
                failedToForget: false,
            };
        case FORGET_SUCCEEDED:
            return {
                ...state,
                isForgetting: false,
                successfullyForgot: true,
                failedToForget: false,
            };
        case FORGET_FAILED:
            return {
                ...state,
                isLoadingOne: false,
                isForgetting: false,
                successfullyForgot: false,
                failedToForget: true,
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        getReducer, listReducer, updateReducer,
        forgetReducer
    ]);
}

/* Export CRUD actions */
export const loadPrinter   = getAction;
export const loadPrinters  = listAction;
export const updatePrinter = updateAction;

export const resetPrinters = () => dispatch => dispatch({ type: RESET });

export const forgetPrinter = (printer, callback) => dispatch => {
    dispatch({ type: FORGET });
    Printers.forget(printer)
        .then(result => {
            dispatch({
                type: FORGET_SUCCEEDED,
                result
            });
            callback && callback(/*err*/null, result);
        }).catch(error => {
            dispatch({
                type: FORGET_FAILED,
                error
            });
            callback && callback(error);
        });
}

SioBridge.on('printers_update', (data) => {
    let connectedPrinters = data.map(printer => new Printer(printer));

    const storePrinters = (store.getState().printers.printers || []).map(printer => {
        printer.status = 'disconnected';
        connectedPrinters.forEach(connectedPrinter => {
            if (connectedPrinter._id === printer._id) {
                printer.status = 'connected';
                connectedPrinters = connectedPrinters.filter(connectedPrinter => connectedPrinter._id !== printer._id);
            }
        });

        return printer;
    });
    const printers = storePrinters.concat(connectedPrinters);

    store.dispatch({
        type: 'kronos/printers/LOADING_ITEMS_SUCCESS',
        printers
    });
});
